import type { ConceptDef } from '../types';

export const tallyMarks: ConceptDef = {
  kind: 'tileMatch',
  id: 'tally-marks',
  label: 'Tally Marks',
  category: 'Math',
  description: 'See tally marks; tap the matching numeral.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: 'How many?  ||', answer: '2' },
      { say: 'How many?  |||', answer: '3' },
      { say: 'How many?  ||||', answer: '4' },
      { say: 'How many?  |||||', answer: '5' },
      { say: 'How many?  ||||| |', answer: '6' },
    ],
  },
};
